
import React ,{Component} from 'react';
import { bindActionCreators } from 'redux';
import { withRouter }         from 'react-router-dom';
import { connect }            from 'react-redux';
import { Divider, Pagination, message } from "antd";
import CloudFlyerAPI from '../../../api/CloudFlyerAPI'
import { receiveError } from '../../../api/http'
import LoadingSpinner from '../../../components/Shared/LoadingSpinner'  
import prettysize from '../../../utils' 
import moment from 'moment'

import CreateUserReport from './EachUser/eachUser';

import "./users.scss";

class ActiveJobsList extends Component{
    constructor(props) {
        super(props)

        this.state = {
            loading : false,
            usersList: [],
            pageSize:50,
            page:1,
            total:0

        }

    }

    onPageChange = page => {
        this.setState({page:page})
        CloudFlyerAPI.user_account
            .fetchAllUsers(this.state.pageSize, page)
            .then(({ data }) => {
                this.setState({
                    loading : false,
                    usersList : data.data,
                    pageSize:data?.options?.pageSize,
                    page:data?.options?.page,
                    total:data?.total
              
                })
            })
            .catch(err => {
                const msg = receiveError(null, err).message
                message.error(msg)
            })
    }


    componentDidMount() {
        
        this.setState({
            loading: true,
        })
        CloudFlyerAPI.user_account
            .fetchAllUsers(this.state.pageSize, this.state.page)
            .then(({ data }) => {
                this.setState({
                    loading : false,
                    usersList : data.data,
                    pageSize:data?.options?.pageSize,
                    page:data?.options?.page,
                    total:data?.total

                })
            })
            .catch(err => {
                const msg = receiveError(null, err).message

            })
    }




    render(){
        const UsersTableHeader = <ul>
                                    <li>User Name</li>
                                    <li>Total Usage</li>
                                    <li>Account Name</li>
                                    <li>Registration Date</li>
                                    {/* <li>Signup Date</li> */}
                                    <li>Status</li>
                                    <li>Detail</li>
                                </ul>

        const ReportList = this.state.usersList.map((rl,index)=>{
            return(
                <div>
                    <Divider/>
                    <CreateUserReport 
                        key = {rl.id}
                        name = {rl.username}
                        storage = {prettysize(rl.lastMonthUsage)}
                        source = {rl.accountName}
                        activeDate = {moment(rl.createDate).format('MM/DD/YYYY - hh:mm')}
                        signupDate = {moment(rl.signupDate).format('MM/DD/YYYY - hh:mm')}
                        status = {rl.status}
                    />
                </div>
            )
        })
        return(
            <div className="active-jobs-wrapper">
                <div className="header">
                    <h3>Users</h3>
                </div>
                <div className="table-header">
                    {UsersTableHeader}
                </div>
                <div>
                    {ReportList}
                </div>
                <Divider/>
                <div className="page-pagination">
                    <Pagination 
                    size="small" 
                    onChange={this.onPageChange} 
                    showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                    total={this.state.total} 
                    current={this.state.page}
                    pageSize={this.state.pageSize}/>

                </div>
            </div>
        )
    }
}

export default withRouter(
    connect(
    //   mapStateToProps,
    //   mapDispatchToProps
    )(ActiveJobsList)
  );